import React, { useState } from "react";
import { CloseButton, Dropdown, DropdownButton, Table, Pagination } from "react-bootstrap";

const AttendancePopup = ({ setVisiblePopup, studentId, name, statusList }) => {
  const closePopup = () => {
    setVisiblePopup(false);
  };

  const itemsPerPage = 5;
  const groupedData = statusList.reduce((acc, item) => {
    acc[item.moduleNumber] = acc[item.moduleNumber] || [];
    acc[item.moduleNumber].push(item);
    return acc;
  }, {});
  const totalPages = Math.ceil(Object.keys(groupedData).length / itemsPerPage);

  const [currentPage, setCurrentPage] = useState(1);
  const [updatedAttendanceStates, setUpdatedAttendanceStates] = useState(statusList);

  const handleStatusChange = (index, newState) => {
    const updatedStates = [...updatedAttendanceStates];
    updatedStates[index].attendanceState = newState;
    setUpdatedAttendanceStates(updatedStates);
  };

  const attendanceStateMapper = {
    ATTENDANCE: "출석",
    ABSENCE: "결석",
    LATE: "지각",
    EXCUSED_ABSENCE: "공결",
  };

  const visibleWeeks = Object.entries(groupedData).slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      <div onClick={closePopup} className="backdrop w-100 h-100 position-fixed top-0 start-0"></div>
      <div
        className="bg-white position-fixed position-center p-4 rounded-2 popupContainer w-100"
        style={{ maxHeight: "80vh", overflowY: "auto" }}
      >
        <div className="d-flex align-items-center justify-content-between">
          <h3 className="h2 text-gray1 fw-bold py-2 mb-3">출석 상세</h3>
          <CloseButton onClick={closePopup} style={{ fontSize: "24px" }} />
        </div>

        <div className="border border-start-0 border-end-0">
          <ul className="py-3">
            <li className="d-flex">
              <h4 className="fw-bold me-5 my-1">학번</h4>
              <span>{studentId}</span>
            </li>
            <li className="d-flex">
              <h4 className="fw-bold me-5 my-1">이름</h4>
              <span>{name}</span>
            </li>
          </ul>
        </div>

        {/* Pagination */}
        <Pagination className="pagination-custom mt-3">
          <Pagination.Prev
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          />
          {Array.from({ length: totalPages }, (_, i) => (
            <Pagination.Item
              key={i + 1}
              active={i + 1 === currentPage}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
          />
        </Pagination>

        {/* Table */}
        <Table className="table-custom">
          <thead>
            <tr className="fw-bold">
              <th>주차</th>
              <th>출결 날짜</th>
              <th>교시</th>
              <th>출결현황</th>
            </tr>
          </thead>
          <tbody>
            {visibleWeeks?.map(([week, records]) => {
              return records.map((record, recordIndex) => {
                return record.attendanceSummaries.map((item, itemIndex) => {
                  const lastIndex = record.attendanceSummaries.length - 1;
                  return (
                    <tr key={`${record.moduleNumber}-${itemIndex}`}>
                      {/* Render moduleNumber only for the first row of each module */}
                      {recordIndex === 0 && itemIndex === 0 && (
                        <td
                          rowSpan={record.attendanceSummaries.length}
                          className="CHA_LIGHT align-middle text-center"
                          style={{ backgroundColor: "#EAF2FF" }}
                        >
                          {record.moduleNumber}
                        </td>
                      )}
                      <td className={`align-middle text-center ${lastIndex === itemIndex ? "" : "border-none"}`}>{item.date}</td>
                      <td className={`align-middle text-center ${lastIndex === itemIndex ? "" : "border-none"}`}>{item.contentNumber}교시</td>
                      <td className={`align-middle text-center ${lastIndex === itemIndex ? "" : "border-none"}`}>
                        <DropdownButton
                          title={attendanceStateMapper[item.attendanceState]}
                          variant={
                            item.attendanceState === "ABSENCE"
                              ? "danger"
                              : item.attendanceState === "LATE"
                              ? "warning"
                              : item.attendanceState === "EXCUSED_ABSENCE"
                              ? "success"
                              : "primary"
                          }
                          onSelect={(eventKey) =>
                            handleStatusChange(record.moduleNumber, eventKey)
                          }
                        >
                          <Dropdown.Item eventKey="ATTENDANCE">출석</Dropdown.Item>
                          <Dropdown.Item eventKey="LATE">지각</Dropdown.Item>
                          <Dropdown.Item eventKey="EXCUSED_ABSENCE">공결</Dropdown.Item>
                          <Dropdown.Item eventKey="ABSENCE">결석</Dropdown.Item>
                        </DropdownButton>
                      </td>
                    </tr>
                  );
                });
              });
            })}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default AttendancePopup;

